import React from 'react';

import './styles.scss';
import {Column, Row} from '../../layout';
import * as fonts from '../../../util/fonts';
import StepImage from './step-image/StepImage';
import {Step} from '../Stepper';
import colors from '../../../util/colors';
import {compose} from 'redux';
import {connect} from 'react-redux';

interface StepperHeaderProps {
  currentStep: number;
  steps: Step[];
  buStyles: any;
}

function StepperHeader({currentStep, steps, buStyles}: StepperHeaderProps) {
  return (
    <Row className="stepper-header-row">
      {steps.map((step) => {
        let stepFill = '';
        let stepStatus = '';
        if (step.index === currentStep) {
          stepFill = buStyles?.primaryColor || colors.blue;
          stepStatus = 'step-active';
        } else if (step.index < currentStep) {
          stepFill = colors.black;
          stepStatus = 'step-complete';
        } else {
          stepFill = colors.lightGrey;
          stepStatus = 'step-incomplete';
        }

        return (
          <Column
            key={`header-step-${step.index}`}
            className={stepStatus}
            style={{width: '25rem'}}>
            <StepImage step={step.index + 1} stepFill={stepFill} />

            <div
              className="stepper-step-label"
              style={{...fonts.ML, ...fonts.Medium}}>
              {step.index === currentStep && step.label}
            </div>
          </Column>
        );
      })}
    </Row>
  );
}
const mapStateToProps = ({globalStyles}: any) => ({
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(StepperHeader));
